import { render, staticRenderFns } from "./AddAnAppointment.vue?vue&type=template&id=4f733024"
import script from "./AddAnAppointment.vue?vue&type=script&lang=ts"
export * from "./AddAnAppointment.vue?vue&type=script&lang=ts"
import style0 from "./AddAnAppointment.vue?vue&type=style&index=0&id=4f733024&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports